<template>
  <!-- 위젯 상태 3종(로딩/에러/빈결과) 공통 래퍼. SPEC-MFR-DASHBOARD-001 S-2.2~S-2.4 -->
  <div class="widget-state-wrap">
    <div v-if="loading" class="widget-state-loading">
      <a-spin size="large" />
    </div>
    <div v-else-if="error" class="widget-state-error">
      <i class="fa-solid fa-triangle-exclamation" />
      <span>{{ $t('dashboard_widget_load_err') }}</span>
      <a-button size="small" @click="$emit('retry')">
        {{ $t('dashboard_widget_retry') }}
      </a-button>
    </div>
    <div v-else-if="isEmpty" class="no-result-wrap no-result-height d-flex">
      <div class="no-result d-flex">
        <img src="../../../assets/img/bubble.svg" class="bubble" />
        <span>{{ emptyMessage || $t('dashboard_widget_empty') }}</span>
      </div>
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'DashboardWidgetState',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['retry'],
};
</script>

<style scoped>
.widget-state-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

.widget-state-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 160px;
  text-align: center;
}

.widget-state-error i {
  font-size: 20px;
  color: #f5a623;
}

.widget-state-error span {
  font-size: 14px;
  color: #6e747c;
}
</style>
